import { Chatbot } from 'lib/ai-assistant';
import { useMemo } from 'react';
import { Outlet } from 'react-router';
import { ErrorHandler, Loading } from 'ui';
import { useUser } from 'features/auth';
import { useAiAssistantPermissions } from 'permissions/ai-assistant';
import { ChatSocket } from './chat-socket';
import { BothUserError, NodeUserError, RailsUserError } from './errors/errors';
import { FetchUserError } from './fetch-user-error';
import { useGetErrorMessage } from './hooks';
import { useFetchUserData } from './hooks/useFetchUserData';

const FetchUser = () => {
  const user = useUser({ requiredAuth: false });
  const { canViewAiChat } = useAiAssistantPermissions();
  const getErrorMessage = useGetErrorMessage();
  const { isLoading, nodeError, railsError } = useFetchUserData();

  const error = useMemo(() => {
    if (nodeError && railsError) {
      return new BothUserError(nodeError, railsError);
    }

    if (railsError) {
      return new RailsUserError(railsError);
    }

    if (nodeError) {
      return new NodeUserError(nodeError);
    }

    return null;
  }, [railsError, nodeError]);

  if ((isLoading || !user) && !error) {
    // TODO: optimize screen, create layout skeleton for this
    return <Loading viewportHeight />;
  }

  return (
    <ErrorHandler
      error={error}
      fallbackRender={(thrownError) => {
        const { subTitle } = getErrorMessage(thrownError);
        return <FetchUserError subTitle={subTitle} />;
      }}
    >
      <ChatSocket />
      <Outlet />
      {canViewAiChat({}) ? <Chatbot /> : undefined}
    </ErrorHandler>
  );
};

export default FetchUser;
